import { useEffect, useState } from "react";
import Calendar, { CalendarTileProperties, ViewCallback } from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useSelector } from "react-redux";
import { retrieveEventCalendar, retrieveEventCalendarByMonth } from "../../../redux/slice/event-calendar-slice";
import { RootState, useAppDispatch } from "../../../redux/store";

type CalendarType = {
  parentDate: string;
  setParentDate: Function;
};

const EventCalendar = (props: CalendarType) => {
  let currentDate = new Date();
  let currentMonth = currentDate.getMonth() + 1;
  let currentYear = currentDate.getFullYear();

  const { data: calendarByMonthData } = useSelector((state: RootState) => state.eventCalendarByMonth);
  const dispatch = useAppDispatch();

  const { parentDate, setParentDate } = props;
  const [activeDate, setActiveDate] = useState("Selected Date: " + parentDate);
  const [value, setValue] = useState(currentDate);
  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);
  const [eventsDate, setEventsDate] = useState<Array<number>>([value.getDate()]);
  const [showNextMonthIcon, setShowNextMonthIcon] = useState(false);
  const [showPrevMonthIcon, setShowPrevMonthIcon] = useState(false);
  const [showNextYearIcon, setShowNextYearIcon] = useState(false);
  const [showPrevYearIcon, setShowPrevYearIcon] = useState(false);

  useEffect(() => {
    setActiveDate("Selected Date: " + formatDate(value));
    setParentDate(formatDate(value));
  }, [value, setParentDate]);

  useEffect(() => {
    let request = {
      monthId: month,
      year: year,
    };

    setShowNextMonthIcon(false);
    setShowPrevMonthIcon(false);
    setShowNextYearIcon(false);
    setShowPrevYearIcon(false);

    dispatch(retrieveEventCalendarByMonth(request));
  }, [dispatch, month, year]);

  useEffect(() => {
    if (calendarByMonthData?.eventInfoItemsList?.length > 0) {
      let newEventsDate: Array<number> = [];
      calendarByMonthData.eventInfoItemsList.forEach((item) => {
        let date = new Date(item.startDateTime);
        let endDate = new Date(item.endDateTime);

        while (date <= endDate) {
          newEventsDate.push(date.getDate());
          date.setDate(date.getDate() + 1);
        }
        setEventsDate(newEventsDate);
        return;
      });
    }

    setShowNextMonthIcon(calendarByMonthData.hasEventsInFutureMonths);
    setShowPrevMonthIcon(calendarByMonthData.hasEventsInPastMonths);
    setShowNextYearIcon(calendarByMonthData.hasEventsInFutureYear);
    setShowPrevYearIcon(calendarByMonthData.hasEventsInPastYear);

  }, [calendarByMonthData]);

  function tileClassName({ date, view }: CalendarTileProperties) {
    if (view === "month") {
      if (date.getDate() !== value.getDate() && eventsDate.find((x) => x === date.getDate())) {
        return "eventstyle";
      }
    }

    return "";
  }

  const onActiveStartDateChange: ViewCallback = ({ action, activeStartDate, value, view }) => {
    let activeMonth = activeStartDate.getMonth() + 1;
    let activeYear = activeStartDate.getFullYear();

    if (activeMonth === currentMonth && activeYear === currentYear) {
      setEventsDate([]);
      setValue(currentDate);
      setMonth(currentMonth);
      setYear(currentYear);
    } else {
      setEventsDate([]);
      setValue(activeStartDate);
      setMonth(activeMonth);
      setYear(activeYear);
    }
  };

  return (
    <div className="control-pane">
      <div className="control-section">
        <div className="calendar-control-section" style={{ overflow: "auto" }}>
          <Calendar onChange={setValue} value={value} tileClassName={tileClassName} showNeighboringMonth={false} onActiveStartDateChange={onActiveStartDateChange} calendarType="US" nextLabel={showNextMonthIcon ? undefined : null} prevLabel={showPrevMonthIcon ? undefined : null} next2Label={showNextYearIcon ? undefined : null} prev2Label={showPrevYearIcon ? undefined : null}></Calendar>
          <label id="date_label">{activeDate}</label>
        </div>
      </div>
    </div>
  );
};

export default EventCalendar;

const formatDate = (date: Date) => {
  return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
};